<template>
    <div class="block-editor ticimax-select-order">
        <section v-if="!channel">
            <a-result status="warning" title="Ticimax API not connected">
                <template #extra>
                    <div class="d-flex align-items-center justify-content-center">
                        <SupsisButton primary ghost @click="gotoTicimax"> Connect to Ticimax-V2</SupsisButton>
                    </div>
                </template>
            </a-result>
        </section>
        <template v-else>
            <section class="active-connection">
                <div data-small="true" class="logos">
                    <div class="logo1">
                        <img class="custom-block-logo" src="/static/img/supsis-logo2.png" />
                    </div>
                    <span class="material-icons"> add </span>
                    <div class="logo2">
                        <TicimaxIcon class="custom-block-logo" />
                    </div>
                </div>
                <div class="active-connection-text">
                    <div><span>Connected with</span> <b>Ticimax-V2</b></div>
                </div>
            </section>

            <div class="ticimax-select-order-wrapper">
                <div class="inputTitle">Ticimax Müşteri Telefon Numarası <b>Format: (05********)</b></div>
                <div class="text-editor-wrapper">
                    <TiptapEditor
                        v-model="clone.customerContact"
                        :show-attributes="true"
                        :max-character-count="64"
                        :show-emoji="false"
                        placeholder="Müşteri Telefon Numarası"
                        :rows="1"
                    />
                </div>
                <div class="mt-4">
                    <a-alert type="info" show-icon>
                        <div slot="message">
                            <div class="font-weight-bold">Bilgi</div>
                            <div>
                                Bu blok, müşteri iletişim bilgisini (telefon) kullanarak Ticimax'tan sipariş
                                bilgilerini alır ve müşterinin seçim yapabilmesi için siparişleri listeler. Müşteri,
                                siparişler arasından birini seçtikten sonra, seçilen siparişin bilgileri attribute'lara
                                kaydedilir ve success bloğuna yönlendirilir.
                            </div>
                        </div>
                    </a-alert>
                </div>
            </div>

            <div class="inputTitle mt-5 mb-2 font-weight-bold">{{ $t("chatbotv2.followingAttributesFilled") }}</div>
             <section class="next-step-filled-items-wrapper">
                <div class="logos middle-section" v-for="attr in nextStepFilledValue" :key="attr">
                    <AttributeIconPreview :attribute="attr" />
                    <span class="ml-2">
                        <AttributeLabel :attribute="attr" />
                    </span>
                </div>
            </section>
        </template>
    </div>
 </template>

 <script>
 import log2 from "../../../../../../../utils/log2";
 import TiptapEditor from "../../common/TiptapEditor";
 import AttributeLabel from "../../common/tiptap-extensions/AttributeLabel";
 import AttributeIconPreview from "../../common/AttributeIconPreview";
 import _ from "lodash";
 import { mapState } from "vuex";
 import SupsisButton from "../../../../../Settings/components/SupsisButton.vue";
 import TicimaxIcon from "../../../integrations/svg/TicimaxIcon.vue";

 const log = log2("TicimaxV2SelectOrder");
 export default {
     name: "TicimaxV2SelectOrder",
     components: { SupsisButton, TiptapEditor, AttributeLabel, AttributeIconPreview,TicimaxIcon },
     props: {
         value: {
             type: Object,
             default: () => ({ customerContact: "{{phone}}" }),
         },
     },
     data() {
         return {
             clone: _.cloneDeep(this.value),
             nextStepFilledValue: [
                 "ticimax_order_id",
                 "ticimax_order_number",
                 "ticimax_order_status",
                 "ticimax_order_price",
                 "ticimax_order_date",
                 "ticimax_track_number",
                 "ticimax_track_url",
             ],
         };
     },
     computed: {
         ...mapState({
             channel: (state) => state.channel.channels.find((x) => x.type === "ticimax-v2"),
         }),
     },
     methods: {
         gotoTicimax() {
             this.$router.push("/integrations/Ticimax-V2");
         },
     },
     mounted() {
         log("mounted");
     },
     watch: {
         clone: {
             handler(val) {
                 log("clone changed", val);
                 this.$emit("input", val);
             },
             deep: true,
         },
         value(val) {
             if (_.isEqual(val, this.clone)) {
                 return;
             }
             this.clone = _.cloneDeep(val);
         },
     },
 };
 </script>

 <style lang="scss">
 .block-editor.ticimax-select-order {
     padding: 30px 30px 0;

     .active-connection {
         align-items: center;
         background: #fff;
         border-radius: 6px;
         display: flex;
         font-size: 14px;
         line-height: 18px;
         margin-bottom: 20px;
         overflow: hidden;
         padding: 20px;
         width: 100%;
         word-break: break-word;

         .logos {
             align-items: center;
             display: flex;
             flex-shrink: 0;
             margin-right: 15px;
             margin-top: 4px;

             .logo1 {
                 background: #4a6586;
             }

             .logo2 {
                 background: #fff;
                 display: flex;
                 align-items: center;
                 justify-content: center;
             }

             .logo1,
             .logo2 {
                 height: 30px;
                 padding: 4px;
                 width: 30px;
             }
         }

         .filled-attributes {
             margin: 0px 0px -17px -50px !important;
         }
     }

     .next-step-filled-items-wrapper {
         background: #fff;
         border-radius: 6px;
         font-size: 14px;
         line-height: 18px;
         margin-bottom: 20px;
         padding: 20px;
         width: 100%;

         .middle-section {
             background: #ffdc66;
             cursor: pointer;
             transition: all 0.3s;
             border-radius: 10px;
             box-decoration-break: clone;
             display: flex;
             justify-content: center;
             padding: 5px;
             width: fit-content;
             margin: 5px;
             align-items: center;
             font-weight: 800;
         }
     }

     .active-connection-text {
         flex-grow: 1;
         flex-shrink: 0;
         width: 0;

         div {
             overflow: hidden !important;
             text-overflow: ellipsis;
             white-space: pre-wrap;
         }
     }

     .ticimax-select-order-wrapper {
         .inputTitle {
             margin-bottom: 10px;
             font-weight: 600;
             font-size: 16px;
             line-height: 20px;
         }

         .editable-editor {
             p {
                 margin-bottom: 0;
             }
         }
     }
 }
 </style>


